import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderDeliveryStatus } from '../models/order-delivery-status.model';

const CONTENT_TYPE_JSON_HEADER = { 'Content-Type': 'application/json' };
@Injectable({
  providedIn: 'root',
})
export class NyabHomeSearchService {
  constructor(
    protected http: HttpClient,
    protected occEndPointService: OccEndpointsService
  ) { }

  getOrderStatus(orderNum: string): Observable<OrderDeliveryStatus> {
    let headers = new HttpHeaders({
      ...CONTENT_TYPE_JSON_HEADER,
    });
    let url = this.occEndPointService.buildUrl('orderDeliveryStatus');
    return this.http.post<OrderDeliveryStatus>(
      url,
      {
        orderNum,
      },
      { headers }
    );
  }
}
